"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasCancellationReasons = exports.wasNotInitializedWithAppointmentData = exports.shouldSkipProvider = exports.isCancelationExpired = exports.isCancelationDisabled = exports.isAppointmentCanceled = exports.hasAppointmentBeenMissed = exports.hasAppointment = void 0;
const moment_1 = __importDefault(require("moment"));
const APPOINTMENT_CANCELED_VALUE = 'canceled';
const hasAppointment = '@guard/HAS_APPOINTMENT';
exports.hasAppointment = hasAppointment;
const isAppointmentCanceled = '@guard/IS_APPOINTMENT_CANCELED';
exports.isAppointmentCanceled = isAppointmentCanceled;
const isCancelationDisabled = '@guard/IS_CANCELATION_DISABLED';
exports.isCancelationDisabled = isCancelationDisabled;
const isCancelationExpired = '@guard/IS_CANCELATION_EXPIRED';
exports.isCancelationExpired = isCancelationExpired;
const shouldSkipProvider = '@guard/SHOULD_SKIP_PROVIDER';
exports.shouldSkipProvider = shouldSkipProvider;
const wasNotInitializedWithAppointmentData = '@guard/WAS_NOT_INITIALIZED_WITH_APPOINTMENT_DATA';
exports.wasNotInitializedWithAppointmentData = wasNotInitializedWithAppointmentData;
const hasAppointmentBeenMissed = '@guard/HAS_APPOINTMENT_BEEN_MISSED';
exports.hasAppointmentBeenMissed = hasAppointmentBeenMissed;
const hasCancellationReasons = '@guard/HAS_CANCELLATION_REASONS';
exports.hasCancellationReasons = hasCancellationReasons;
const guards = {
    [hasAppointment]: (context) => {
        return !!context.appointment;
    },
    [isAppointmentCanceled]: (context) => {
        var _a;
        return ((_a = context.appointment) === null || _a === void 0 ? void 0 : _a.status) === APPOINTMENT_CANCELED_VALUE;
    },
    [isCancelationDisabled]: (context) => {
        var _a;
        return !((_a = context.capabilities) === null || _a === void 0 ? void 0 : _a.isCancelEnabled);
    },
    [isCancelationExpired]: (context) => {
        var _a;
        return !!(0, moment_1.default)((_a = context.appointment) === null || _a === void 0 ? void 0 : _a.latest_cancellation).isBefore((0, moment_1.default)());
    },
    [shouldSkipProvider]: (context) => {
        return !context.services.getProvider;
    },
    [wasNotInitializedWithAppointmentData]: (context) => {
        return !context.appointment && !context.appointmentId;
    },
    [hasAppointmentBeenMissed]: (context) => {
        var _a;
        const appointmentDate = (_a = context.appointment) === null || _a === void 0 ? void 0 : _a.start_datetime;
        return !!appointmentDate && (0, moment_1.default)(appointmentDate).isBefore((0, moment_1.default)());
    },
    [hasCancellationReasons]: (context) => {
        var _a;
        return !!((_a = context.cancellationReasons) === null || _a === void 0 ? void 0 : _a.length);
    }
};
exports.default = guards;
//# sourceMappingURL=guards.js.map